import {Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';

@Component({
    selector: 'checkbox',
    template: `
		<div class="flxRow-start md-checkbox {{class || ''}} {{isDisabled ? 'disabled' : ''}}" style="align-items: center; {{style || ''}}"
			 [ngClass]="ngClass || {}" [ngStyle]="ngStyle || {}">
			<input [id]="id || random" type="checkbox"
				   [(ngModel)]="model"
				   (ngModelChange)="modelChange.emit(model)"/>
			<label style="margin: 0;" [for]="id || random">
				<ng-content></ng-content>
				<i class="fa fa-question-circle" style="font-weight: 400; margin-left: 4px;"
				   *ngIf="tooltipTxt"
				   [tooltip]="tooltipTxt"
				   [placement]="tooltipDirection || 'top'"></i>
			</label>
		</div>
	`,
})
export class CheckboxComponent {
    @Input() model: any;
    @Output() modelChange = new EventEmitter();
    @Input() isDisabled: boolean;
    @Input() tooltipTxt: string;
    @Input() tooltipDirection: string;
    @Input() style: string;
    @Input() ngStyle: string;
    @Input() class: string;
    @Input() ngClass: string;
    @Input() id?: string;

    @HostBinding('attr.id') hostId = null;
    @HostBinding('attr.style') hostStyle = null;
    @HostBinding('attr.class') hostClass = null;
    @HostBinding('attr.ngStyle') hostNgStyle = null;
    @HostBinding('attr.ngClass') hostNgClass = null;

    random = Math.random().toString(36).replace(/[^a-z]+/g, '').substring(0, 18);

}
